import { ButtonGroup, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as MoreSvg } from "go-core/images/svg/actions/more.svg";
import EditAction from "../../../../../../../../../components/Common/CommonActions/EditAction/EditAction";
import RemoveAction from "../../../../../../../../../components/Common/CommonActions/RemoveAction/RemoveAction";
import Tag from "../../../../../../../../../components/Common/Tag/Tag";
import { ImageLinksMode } from "../../../utils/types";

interface Props {
	image?: Record<string, any>;
	handleAppend?: () => void;
	handleEdit?: () => void;
	handleRemove?: () => void;
	index?: number;
	mode?: ImageLinksMode;
}

const ImageLinkItem = ({ image, handleAppend, handleRemove, handleEdit, index, mode }: Props) => {
	const { t } = useTranslation();
	const displayItemName = mode === ImageLinksMode.ADD_TO_EXISTING_FIELDS;
	const displayDropdown = handleRemove || handleEdit;

	if (mode === ImageLinksMode.ADD_TO_EXISTING_FIELDS && !image?.image && !image?.image_link && handleEdit) {
		return (
			<div className="image-link-item" onClick={handleEdit}>
				<span className="add-image">
					<span className="add-image-tex">{`+ ${t("common.action.add", { ns: "lib" })}`}</span>
					{displayItemName && <Tag className="image-tag">{image?.name || t("common.word.default")}</Tag>}
				</span>
			</div>
		);
	}

	if (image && handleEdit) {
		return (
			<div onClick={handleEdit} className="image-link-item">
				{displayDropdown && (
					<Dropdown onClick={(evt) => evt.stopPropagation()} as={ButtonGroup} className="actions">
						<Dropdown.Toggle draggable={false} as={MoreSvg}>
							{t("common.action.more", { ns: "lib" })}
						</Dropdown.Toggle>
						<Dropdown.Menu>
							{handleRemove && (
								<Dropdown.Item onClick={handleRemove}>
									<RemoveAction />
								</Dropdown.Item>
							)}
							{handleEdit && (
								<Dropdown.Item onClick={handleEdit}>
									<EditAction />
								</Dropdown.Item>
							)}
						</Dropdown.Menu>
					</Dropdown>
				)}
				<img
					src={
						image.image_link
							? image.image_link.default_link
							: `data:${image.image?.type};base64,${image.image?.image_data}`
					}
					alt={`Item group image #${(index ?? 0) + 1}`}
				/>
				{image.tag && <Tag className="image-tag">#{image.tag}</Tag>}
				{displayItemName && <Tag className="image-tag">{image.name || t("common.word.default")}</Tag>}
			</div>
		);
	}

	if (mode === ImageLinksMode.ADD_NEW) {
		return (
			<div className="image-link-item" onClick={handleAppend}>
				<span className="add-image">
					<span className="add-image-text">{`+ ${t("modules.menu.action.add_more_photos.title")}`}</span>
				</span>
			</div>
		);
	}

	return null;
};

export default ImageLinkItem;
